import { ExternalSiteType } from "@shared/common/types/site";
import React from "react";

interface ISiteTypeNameProps {
  siteType?: ExternalSiteType | "WEB" | string | null;
}

const SiteTypeName: React.FC<ISiteTypeNameProps> = ({ siteType }) => {
  if (!siteType) {
    return <></>;
  }

  const getName = () => {
    switch (siteType) {
      case "OOPY":
        return "우피";
      case "SIXSHOP":
        return "식스샵";
      case "MAKESHOP":
        return "메이크샵";
      case "IMWEB":
        return "아임웹";
      case "CAFE24":
        return "카페24";
      case "SHOPIFY":
        return "Shopify";
      case "WIX":
        return "윅스";
      case "SHOPBY":
        return "샵바이";
      case "SHOPBY_PRO":
        return "샵바이 프로";
      case "GODOMALL":
        return "고도몰";
      case "WEB":
        return "웹사이트";
      case "WORDPRESS":
        return "워드프레스";
      case "NAVER_SMARTSTORE":
        return "스마트스토어";
    }
  };

  return <span>{getName()}</span>;
};

export default React.memo(SiteTypeName);
